import React from 'react';
import * as Aphrodite from 'aphrodite/no-important';
import { Platform } from '../tools/platform';
export { Platform } from '../tools/platform';

require('../css/base_components.less');

const baseStyles = _createStyleSheet({
  scrollerStyle: {
    overflowX: 'hidden',
    overflowY: 'scroll',
    overflowScroll: 'contain',
  },
  scrollerStyleHorizontal: {
    overflowX: 'scroll',
    overflowY: 'hidden',
    overflowScroll: 'contain',
  },
  contentContainerStyle: {
    overflowX: 'auto',
    overflowY: 'auto',
  },
});

export class View extends React.PureComponent<any> {
  render() {
    const {
      style,
      children,
      className: extraClass,
      pointerEvents: _,
      getDiv,
      ...other_props
    } = this.props;

    const { inlineStyle, className } = resolveStyle(style, extraClass);

    const extra_props = {};
    if (getDiv) {
      extra_props.ref = getDiv;
    }

    return (
      <div
        className={className}
        style={inlineStyle}
        {...other_props}
        {...extra_props}
      >
        {children}
      </div>
    );
  }
}

export class ScrollView extends React.PureComponent<any> {
  addScrollTop(delta) {
    if (this._scrollRef) {
      this._scrollRef.scrollTop += delta;
    }
  }
  setScrollTop(value) {
    if (this._scrollRef) {
      this._scrollRef.scrollTop = value;
      return this._scrollRef.scrollTop;
    }
  }
  _onScrollRef = (ref) => {
    this._scrollRef = ref;
  };

  render() {
    const {
      style,
      contentContainerStyle,
      horizontal,
      children,
      onScroll,
      ...other_props
    } = this.props;
    const base_style = horizontal
      ? baseStyles.scrollerStyleHorizontal
      : baseStyles.scrollerStyle;
    return (
      <View
        getDiv={this._onScrollRef}
        style={[base_style, style]}
        {...other_props}
      >
        <View
          style={[baseStyles.contentContainerStyle, contentContainerStyle]}
          onScroll={onScroll}
        >
          {children}
        </View>
      </View>
    );
  }
}

export class TouchableWithoutFeedback extends React.PureComponent<any> {
  render() {
    const {
      style,
      className: extraClass,
      children,
      onPress,
      ...other_props
    } = this.props;

    const { className, inlineStyle } = resolveStyle(style, extraClass);

    return (
      <div
        onclick={onPress}
        className={className + ' touchable-without-feedback'}
        style={inlineStyle}
        {...other_props}
      >
        {children}
      </div>
    );
  }
}

function nop() {}

export class TouchableHighlight extends React.PureComponent<any> {
  static defaultProps = {
    underlayColor: 'rgba(0,0,0,0.5)',
  };

  render() {
    const {
      style,
      children,
      underlayColor,
      pointerEvents: _,
      onPress,
      ...other_props
    } = this.props;

    const { className, inlineStyle } = resolveStyle(style);

    const inner_style = { backgroundColor: underlayColor };

    return (
      <div
        className={className + ' touchable-highlight'}
        ontouchstart={nop}
        onclick={onPress}
        style={inlineStyle}
        {...other_props}
      >
        <div className='touchable-highlight-underlay' style={inner_style} />
        {children}
      </div>
    );
  }
}

export class Text extends React.PureComponent<any> {
  render() {
    const { style, children, pointerEvents: _, ...other_props } = this.props;

    const { className, inlineStyle } = resolveStyle(style);

    return (
      <div className={className} style={inlineStyle} {...other_props}>
        {children}
      </div>
    );
  }
}
export class TextInput extends React.Component<any> {
  _onChange = (e) => {
    const { onChangeText } = this.props;
    if (onChangeText) {
      onChangeText(e.target.value);
    }
  };

  render() {
    const {
      style,
      className: extraClass,
      onSubmitEditing,
      multiline,
      ...other_props
    } = this.props;

    const { className, inlineStyle } = resolveStyle(style, extraClass);

    let input;
    if (multiline) {
      input = (
        <textarea
          className={'base-component-text-input ' + className}
          style={inlineStyle}
          onChange={this._onChange}
          onInput={this._onChange}
          {...other_props}
        />
      );
    } else {
      input = (
        <input
          className={'base-component-text-input ' + className}
          style={inlineStyle}
          onChange={this._onChange}
          onInput={this._onChange}
          {...other_props}
        />
      );
    }
    let content;
    if (onSubmitEditing) {
      content = (
        <form
          className={'base-component-text-input-form'}
          onSubmit={onSubmitEditing}
        >
          {input}
        </form>
      );
    } else {
      content = input;
    }
    return content;
  }
}

export class Image extends React.PureComponent<any> {
  static defaultProps = {
    resizeMode: 'contain',
  };

  render() {
    const { style, resizeMode, source } = this.props;

    const { className, inlineStyle } = resolveStyle(style);

    if (resizeMode === 'tile') {
      inlineStyle.backgroundRepeat = 'repeat';
    } else {
      inlineStyle.backgroundSize = resizeMode;
      inlineStyle.backgroundRepeat = 'no-repeat';
      inlineStyle.backgroundPosition = 'center center';
    }

    const url = (source && (source.src || source.uri)) || source;
    inlineStyle.backgroundImage = "url('" + url + "')";

    return <div className={className} style={inlineStyle} />;
  }
}

export function resolveStyle(style, extra_class) {
  let className = 'base-component ';
  const inlineStyle = {};
  const aphrodite_style_list = [];

  function _handleStyle(sub_style) {
    if (sub_style && sub_style._name) {
      aphrodite_style_list.push(sub_style);
    } else if (Array.isArray(sub_style)) {
      sub_style.forEach(_handleStyle);
    } else if (typeof sub_style === 'object' && sub_style) {
      Object.assign(inlineStyle, sub_style);
    }
  }
  _handleStyle(style);
  if (aphrodite_style_list.length > 0) {
    className += css(aphrodite_style_list);
  }
  if (extra_class) {
    className += ' ' + extra_class;
  }
  return {
    className,
    inlineStyle,
  };
}

function _createStyleSheet<T>(style_map: T): T {
  return Aphrodite.StyleSheet.create(style_map);
}

type Dimension = {
  width: number;
  height: number;
};

let g_dimensions: Dimension | null = null;
let g_resizeSet = false;
function _getDimensions(_ignore: string): Dimension | null {
  if (!g_dimensions) {
    const app_container = document.getElementById('app-container');
    if (app_container !== null) {
      if (!g_resizeSet) {
        g_resizeSet = true;
        window.addEventListener('resize', _onResize);
      }
      g_dimensions = {
        width: app_container.clientWidth,
        height: app_container.clientHeight,
      };
    }
  }
  return g_dimensions;
}
function _onResize() {
  g_dimensions = null;
}

export const StyleSheet = {
  create: _createStyleSheet,
  hairlineWidth: 1 / window.devicePixelRatio,
};
export const Dimensions = {
  get: _getDimensions,
};
export const PixelRatio = {
  get: () => window.devicePixelRatio || 1,
};

function css(...args) {
  return Aphrodite.css(...args);
}
export class StatusBar extends React.PureComponent {
  static setBarStyle() {}
  static setBackgroundColor() {}
  render() {
    return null;
  }
}

export function ActivityIndicator() {
  return null;
}
export function Animated() {}
export const Easing = false;

function alert(title: string, message?: string, buttons?: any) {
  if (buttons && buttons.length > 1) {
    const result = window.confirm(message || title);
    if (result) {
      buttons[0].onPress();
    } else {
      buttons[1].onPress();
    }
  } else {
    window.alert(message || title);
    if (buttons && buttons[0] && buttons[0].onPress) {
      buttons[0].onPress();
    }
  }
}
export const Alert = {
  alert,
};
export const AppState = {
  addEventListener: () => {},
};
export const RefreshControl = {};
export const Linking = {
  openURL: (url) => {
    window.location.href = url;
  },
};
export const KeyboardAvoidingView = View;
export const Share = {
  share: (opts, settings?: any) => Promise.resolve(),
};

export default {
  ActivityIndicator,
  Alert,
  Animated,
  AppState,
  Dimensions,
  Image,
  KeyboardAvoidingView,
  Linking,
  Platform,
  PixelRatio,
  RefreshControl,
  ScrollView,
  Share,
  StatusBar,
  StyleSheet,
  Text,
  TextInput,
  View,
  TouchableHighlight,
  TouchableWithoutFeedback,
  css,
  resolveStyle,
};
